import auth from '../modules/authentication/handlers';
import routing from '../modules/routing/handlers';
import customer from './customer/handlers';

export default { auth, routing, customer };



// WEBPACK FOOTER //
// ./src/frontend/admin/handlers.js